import objectUtils from "../../util/objectUtils";
import axios from "axios";

export default {
    state: () => ({
        sail : null,

        sailsLite: null,
        routeList : null,
        route : null,
        sailDeckRoom : null,

        sailReportData: null
    }),
    mutations: {
        setRouteList:function (state,routeList){
            state.routeList = routeList;
        },
        setSail:function (state,sail){
            state.sail = sail
        },
        setRoute:function (state,route){
            state.route = route
        },
        setSailDeckRoom:function (state,sailDeckRoom){
            state.sailDeckRoom = sailDeckRoom
        },
        setSailsLite:function(state, sailsLite){
            state.sailsLite = sailsLite;
        },
        setSailReportData:function (state, sailReportData){
            state.sailReportData = sailReportData;
        }
    },
    getters: {
        getSail : state => {
            return state.sail
        },
        getRouteList : state => {
            return state.routeList
        },
        getRoute : state => {
            return state.route
        },
        getSailDeckRoom : state => {
            return state.sailDeckRoom
        },
        getSailsLite : state => {
            return state.sailsLite
        },
        getSailsLiteMap : state => {
            if(!state.sailsLite) return [];
            return state.sailsLite.reduce(function (map, sail) {
                map[sail.id] = sail;
                return map;
            }, {});
        },
        getSailReportData : state => {
            return state.sailReportData;
        }
    },
    actions: {
        loadSailId(context, id) {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            let cruiseId;
            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/"+id, {headers})
                .then((response) => {
                    context.commit("setSail", response.data);
                    cruiseId = response.data.cruiseId;
                    return context.dispatch("loadRoomList", cruiseId);
                })
                .then((response) => {
                    return context.dispatch("loadDeckList", cruiseId);
                })
                .then((response) => {
                    return context.dispatch("loadRouteList", id)
                })
                .then((response) => {
                    return axios.get(context.getters.getServiceUrl + "/admin-api/sail/"+id+"/cruiseRooms", {headers});
                })
                .then((response) => {
                    this.commit("setCruiseRoomList", response.data);
                });
        },
        deleteSail(context, sail) {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/sail/"+sail.id, {headers})
                .then((response) => {
                    // let sailList = context.getters.getSailList
                    // sailList.splice(sailList.indexOf(sail), 1)
                    // context.commit("setSailList", sailList);

                    return response.data;
                })
        },
        loadSailList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail", {headers})
                .then((response) => {
                    let sailList = response.data;
                    if(sailList == null){
                        return null;
                    }
                    sailList.sort((a, b) => {
                        let dateA = new Date(a.sailDate);
                        let dateB = new Date(b.sailDate);
                        return dateA - dateB;
                    });

                    return sailList;
                })
        },
        loadSailsLite(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/lite", {headers})
                .then((response) => {
                    let sailList = response.data;
                    if(sailList == null){
                        return null;
                    }
                    sailList.sort((a, b) => {
                        let dateA = new Date(a.sailDate);
                        let dateB = new Date(b.sailDate);
                        return dateA - dateB;
                    });

                    context.commit("setSailsLite", sailList)
                    return sailList;
                })
        },
        loadSailsLiteAll(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/lite/all", {headers})
                .then((response) => {
                    let sailList = response.data;
                    if(sailList == null){
                        return null;
                    }
                    sailList.sort((a, b) => {
                        let dateA = new Date(a.sailDate);
                        let dateB = new Date(b.sailDate);
                        return dateA - dateB;
                    });

                    context.commit("setSailsLite", sailList)
                    return sailList;
                })
        },
        loadRouteList(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/"+id+"/routes", {headers})
                .then((response) => {
                    context.commit("setRouteList", response.data)
                    return response.data;
                })
        },
        updateSail(context){
            let sail = {}
            objectUtils.deepCopy(sail, context.getters.getSail);
            if(sail.sailDate.length === 10){
                sail.sailDate = moment.utc(sail.sailDate,'DD/MM/YYYY').toDate();
            }else{
                sail.sailDate = moment.utc(sail.sailDate).toDate();
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/sail", sail,{headers})
                .then((response) => {
                    this.commit("setSail", response.data)
                    return this.dispatch("loadRouteList",sail.id);
                })
        },
        createSail(context){
            let sail = {};
            objectUtils.deepCopy(sail, context.getters.getSail)
            sail.sailDate = moment.utc(sail.sailDate,'DD/MM/YYYY').toDate();

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/sail", sail,{headers})
                .then((response) => {
                    context.commit("setSail", response.data)
                    return response.data;
                })
        },
        updateRoute(context, route){
            route.sailId = context.getters.getSail.id;

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/route", route,{headers})
                .then((response) => {
                    context.commit("setRoute", null)
                    return context.dispatch("loadSailId", context.getters.getSail.id)
                })
        },
        createRoute(context, route){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/route", route,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateCruiseRoomRules(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/sail/cruiseRooms/rule", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        sailBatchUpdate(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/sail/batch", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        getSailManifest(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/report/manifest/"+request.sailId,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadSailReportData(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/getSailReportData",{headers})
                .then((response) => {
                    context.commit("setSailReportData", response.data);
                    return response.data;
                })
        },
        loadForeCastReportData(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/report/forecast",{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadBookingAgencyCommissionReportData(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/report/get-booking-agency-commission-report",request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        sendSailReport(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/sail/sendSailReport",request,{headers})
                .then((response) => {
                    return response.data;
                })
        }
    }
}

